export default __webpack_public_path__ + "static/media/NGORealCase1.e57c870a.jpg";